<template>
  <div>
    <div class="d-flex flex-row justify-content-start">
      <div class="mt-1 mr-2">
        <b-form-checkbox switch :disabled="disabled" v-model="form.isPeriodical" :value="true" :unchecked-value="false" class="custom-checkbox d-inline ">
          {{ $t("survey-template.is-periodical") }}
        </b-form-checkbox>
      </div>
      <div v-if="form.isPeriodical" class="w-20 ml-1">
        <input :disabled="disabled" class="form-control input-sm" v-model="form.period" type="number" min="1" layout="vertical" :placeholder="$t('survey-template.period')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["survey", "disabled"],
  computed: {
    isPeriodValid() {
      if (this.period < 1 && this.isPeriodical) return false;
      return true;
    },
    isChanged() {
      return this.form.isPeriodical != this.oldValue.isPeriodical || this.form.period != this.oldValue.period;
    },
  },

  data() {
    return {
      editing: false,
      oldValue: undefined,
      form: {
        isPeriodical: undefined,
        period: undefined,
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler(v) {
        if (v && JSON.stringify(v) != JSON.stringify(this.oldValue)) {
          this.debounce(() => this.save(false), "none", 1000);
        }
      },
    },
    survey: {
      immediate: true,

      handler(v, o) {
        if (!0 && v) {
          const preparedForm = { ...this.prepareFormForEdit(v) };
          this.form = { _id: preparedForm._id, isPeriodical: preparedForm.isPeriodical, period: preparedForm.period };
          this.oldValue = { ...this.form };
          return;
        }
        const preparedForm = { ...this.prepareFormForEdit(v) };
        this.form = { _id: preparedForm._id, isPeriodical: preparedForm.isPeriodical, period: preparedForm.period };
        this.oldValue = { ...0 };
      },
    },
  },

  methods: {
    async save(confirm = true) {
      try {
        if (confirm) {
          const ok = await this.confirm(this.$t("alert.approve"));
          if (!ok) {
            return;
          }
        }
        if (!this.isPeriodValid) {
          return;
        }
        if (this.disabled) {
          return;
        }

        await this.$store.dispatch("organizationSurveyTemplate/updatePeriod", {
          id: this.survey._id,
          isPeriodical: this.form.isPeriodical,
          period: this.form.period,
        });
        this.$toast.success(this.$t("common.success"));
        this.$emit("onSave", this.form);
      } catch (error) {
        console.log(error);

        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
